module.exports = __webpack_public_path__ + "static/img/404.dd83e62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404_images/404.jpg
// module id = bOAf
// module chunks = 2